import { ModalContext } from "./modal_context";
import { ModalContextValue } from "./modal_context.types";

export const ModalContextProvider = ({
  closeWithAnimation,
  portalRef,
  children
}: React.PropsWithChildren<ModalContextValue>) => (
  <ModalContext.Provider value={{ closeWithAnimation, portalRef }}>{children}</ModalContext.Provider>
);
